import { PaginationState, SortingState, VisibilityState } from '@tanstack/react-table'

// Convert v8 SortingState array → API order param
// Single-column only — v8 supports multi-sort but API accepts only one sort column at a time
export const sortingToOrder = (sorting: SortingState): Record<string, 'asc' | 'desc'> | undefined => {
    if (!sorting.length) return undefined

    const { id, desc } = sorting[0]

    return { [id]: desc ? 'desc' : 'asc' }
}

interface TableStateParams {
    pagination: PaginationState
    sorting: SortingState
}

// Convert v8 pagination + sorting state → API page/limit/order params.
export const tableStateToQueryParams = ({ pagination, sorting }: TableStateParams) => ({
    page: pagination.pageIndex + 1,
    limit: pagination.pageSize,
    order: sortingToOrder(sorting),
})

// TODO: technical debt — these two converters exist only because v7 stored hiddenColumns as string[]
// and v8 uses VisibilityState (Record<string, boolean>). Backend stores whatever it receives.
// Once all 19 consumers are migrated, ask backend to run a one-time migration converting all
// stored string[] arrays to VisibilityState objects, then drop both functions and read/write
// VisibilityState directly.

// Convert persisted hidden-column array (v7 storage format) → v8 VisibilityState.
export const hiddenToVisibility = (hiddenColumns: string[]): VisibilityState => {
    if (!hiddenColumns?.length) return {}
    return Object.fromEntries(hiddenColumns.map((id) => [id, false]))
}

// Convert v8 VisibilityState → hidden-column array (v7 storage format).
export const visibilityToHidden = (visibility: VisibilityState): string[] =>
    Object.entries(visibility)
        .filter(([, visible]) => !visible)
        .map(([id]) => id)

